export const formatResourceName = (path, sidebarWidth, hasSelected, windowWidth) => {
  if (!path) return '';
  
  // Calculate approximate maximum characters that can fit in the sidebar.
  // Sidebar padding, chip, and duration text take about 160px.
  // A character is roughly 8px wide.
  const currentWidth = hasSelected ? (windowWidth * (sidebarWidth / 100)) : windowWidth;
  const availableWidth = currentWidth - 160; // subtract padding, chip, and duration
  const maxChars = Math.max(12, Math.floor(availableWidth / 8));
  
  if (path.length <= maxChars) {
    return path;
  }
  
  // Simplify segments
  const segments = path.split('/').filter(Boolean);
  if (segments.length === 0) return path;

  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  let simplified = segments.map(seg => {
    if (uuidRegex.test(seg) || seg.length > 20) {
      return '...';
    }
    return seg;
  });

  let result = '/' + simplified.join('/');
  if (result.length <= maxChars) {
    return result;
  }

  // Keep only the last segments
  let wasShifted = false;
  while (simplified.length > 2 && ('.../' + simplified.join('/')).length > maxChars) {
    simplified.shift();
    wasShifted = true;
  }

  return (wasShifted ? '.../' : '/') + simplified.join('/');
};

export const formatTime = (ts) => {
  if (!ts) return '-';
  const date = new Date(ts);
  const pad = (n) => String(n).padStart(2, '0');
  const padMs = (n) => String(n).padStart(3, '0');
  return `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${padMs(date.getMilliseconds())}`;
};
